import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';

import { TrlActivateUser } from '»components/molecules';
import {
  isFinantechActiveClient,
  isHemeraActiveClient,
} from '»utils/clientsUtils';

import {
  IconStyled,
  InnerContainer,
  OuterContainer,
} from './RecoverPassword.styled';

export const RecoverPassword = ({ urlToken }) => {
  const theme = useTheme();

  return (
    <OuterContainer>
      <InnerContainer>
        <IconStyled
          name="iconLogo"
          iconI={
            !isFinantechActiveClient && !isHemeraActiveClient
              ? theme.customLogo.nlogo
              : theme.customLogo.logo
          }
        />
        <TrlActivateUser token={urlToken} />
      </InnerContainer>
    </OuterContainer>
  );
};

RecoverPassword.propTypes = {
  urlToken: PropTypes.string.isRequired,
};
